import moment from 'moment-timezone'
import IndexController from '../index_controller'
import $ from 'jquery'

export default class extends IndexController {
  connect () {
    super.connect()

    $('#logs').dropdown({})
    $('#record_status').dropdown({})
    $('#categories').dropdown({})
    $('#priorities').dropdown({})
    $('#locations').dropdown({})
    if ($('#resolutions').length) {
      $('#resolutions').dropdown({})
    }

    super.initializeFromToDateFilters()

    $('#record_type').dropdown({
      clearable: true,
      forceSelection: false,
      action: function (addedValue, value) {
        if (value === 'CHECKLIST') {
          $('#confirm-checklist-filter').modal('show')
        } else if (value === 'ISSUE') {
          $(this).dropdown('set selected', addedValue)
        } else if (value === 'NOTE') {
          $('#confirm-note-filter').modal('show')
        }
      }
    })

    // Handle Unsetting record type
    $('#record_type').change(function (e) {
      if (e.target.value === '') {
        $('.issue_only_filter').each(function (index, filter) {
          $(filter).removeClass('disabled')
        })
        $('#incomplete-issue-toggle').removeClass('disabled')
      }
    })
  }

  disconnect () {
    $('#record_type').off('change')
  }

  buildFilters () {
    const filters = super.buildFilters()
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].logs = $('#logs').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].record_type = $('#record_type').dropdown('get values') || ''
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].active_status = Array.isArray($('#record_status').dropdown('get values')) && $('#record_status').dropdown('get values').includes('active') ? true : undefined
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].inactive_status = Array.isArray($('#record_status').dropdown('get values')) && $('#record_status').dropdown('get values').includes('complete') ? true : undefined

    const values = $('#record_status').dropdown('get values')

    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].categories = $('#categories').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].priorities = $('#priorities').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].locations = $('#locations').dropdown('get values') || []
    if ($('#resolutions').length) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].resolutions = $('#resolutions').dropdown('get values') || []
    }

    const accountTimezone = localStorage.getItem('accountTimezone')
    const rawFrom = $('#from-date-filter').data('datepicker').getDate()
    const fromDate = rawFrom ? moment.tz([rawFrom.getFullYear(), rawFrom.getMonth(), rawFrom.getDate()], accountTimezone) : moment.invalid()
    const rawTo = $('#to-date-filter').data('datepicker').getDate()
    const toDate = rawTo ? moment.tz([rawTo.getFullYear(), rawTo.getMonth(), rawTo.getDate()], accountTimezone).add(1, 'd').subtract(1, 's') : moment.invalid()

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date = fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date = toDate.unix()
    }

    if (filters.criteria[this.filterSetKeyPrefixValue + '_filters'].record_type === 'CHECKLIST' || filters.criteria[this.filterSetKeyPrefixValue + '_filters'].record_type === 'NOTE') {
      this.disableFilterEvents()

      // issue related filters
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].categories = []
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].priorities = []
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].locations = []
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].resolutions = []

      $('#categories').dropdown('clear')
      $('#priorities').dropdown('clear')
      $('#locations').dropdown('clear')
      if ($('#resolutions').length) { $('#resolutions').dropdown('clear') }

      $('#categories').addClass('disabled')
      $('#priorities').addClass('disabled')
      $('#locations').addClass('disabled')
      if ($('#resolutions').length) { $('#resolutions').addClass('disabled') }
      this.enableFilterEvents()
    }

    if (filters.criteria[this.filterSetKeyPrefixValue + '_filters'].record_type === 'ISSUE') {
      this.disableFilterEvents()
      $('#categories').removeClass('disabled')
      $('#priorities').removeClass('disabled')
      $('#locations').removeClass('disabled')
      if ($('#resolutions').length) { $('#resolutions').removeClass('disabled') }
      this.enableFilterEvents()
    }

    return filters
  }

  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#logs').dropdown('clear')
    $('#record_type').dropdown('clear')
    $('#record_status').dropdown('clear')

    $('#categories').dropdown('clear')
    $('#priorities').dropdown('clear')
    $('#locations').dropdown('clear')
    if ($('#resolutions').length) { $('#resolutions').dropdown('clear') }

    $('#reports-search-input').val('')
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')

    $('#categories').removeClass('disabled')
    $('#priorities').removeClass('disabled')
    $('#locations').removeClass('disabled')
    if ($('#resolutions').length) { $('#resolutions').removeClass('disabled') }
    this.enableFilterEvents()
  }

  removeFilter (event) {
    const filterKey = event.params.filterKey

    if (filterKey === 'record_type') {
      this.disableFilterEvents()
      $('#categories').removeClass('disabled')
      $('#priorities').removeClass('disabled')
      $('#locations').removeClass('disabled')
      if ($('#resolutions').length) { $('#resolutions').removeClass('disabled') }
      this.enableFilterEvents()
    }

    super.removeFilter(event)
  }

  export (event) {
    event.preventDefault()

    if (this.isFilterEmpty()) {
      $('#reportExportModal').modal('show')
    } else {
      window.location.href = event.params.url
    }
  }

  // private methods
  isFilterEmpty () {
    return $('#logs').dropdown('get values').length === 0 &&
      $('#record_type').dropdown('get values').length === 0 &&
      $('#record_status').dropdown('get values').length === 0 &&
      $('#categories').dropdown('get values').length === 0 &&
      $('#priorities').dropdown('get values').length === 0 &&
      $('#locations').dropdown('get values').length === 0 &&
      (!$('#resolutions').length || $('#resolutions').dropdown('get values').length === 0) &&
      $('#from-date-filter').datepicker('getDate') === null &&
      $('#to-date-filter').datepicker('getDate') === null &&
        $('#reports-search-input').val() === ''
  }
}
